import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Autotext, Test } from "@app/definitions/types"
import { stripTags } from "@app/helpers"
import { Modalable } from "@app/Modalable"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { WysiwygComponent } from "@app/utils/wysiwyg/wysiwyg.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { InsertAutotextComponent } from "@app/insert-autotext/insert-autotext.component"
import { StatusComponent } from "@app/status/status.component"

@Component({
	selector: "app-autotext-menu",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenInputComponent,
		WysiwygComponent,
		ModalWrapComponent,
		InsertAutotextComponent,
		StatusComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./autotext-menu.component.html",
})
export class AutotextMenuComponent extends Modalable {
	modalProps: any = null

	rows: Autotext[] = [] //the list of current autoTexts
	showAll: boolean = false
	search: string = ""
	dispRows: any[] = []

	async ngOnInit() {
		//when called to open get the autoTexts from DB
		await this.getRows()
	}
	handleSearch() {
		if (!this.search) {
			this.dispRows = [...this.rows]
			return
		}
		this.dispRows = this.rows.filter(
			(row) =>
				row.name.includes(this.search) ||
				stripTags(row.html_autotext).includes(this.search)
		)
	}
	async getRows() {
		this.rows = (await this.apiService.get_gen_items("autotexts")).autotexts
		this.handleSearch()
	}

	flipShowAll() {
		this.showAll = !this.showAll
		this.rows.forEach((it) => (it.showText = this.showAll))
	}

	async saveField(row: Autotext) {
		const res = await this.apiService.save_gen_field(
			"autotexts",
			row.id,
			"html_autotext",
			row.html_autotext
		)
		if (res.success) {
			this.store.updGenItemRowField(
				"autotexts",
				row.id,
				"html_autotext",
				row.html_autotext
			)
			this.modalService.openToast("update_successfuly")
		}
	}
}
